import LocaleContext from 'locales';
import { useContext } from 'react';

/**
 * @typedef {object} Message 국제화 메시지
 * @property {string} id 스트링 리소스 키
 * @property {object} [values] 스트링 리소스의 변수 목록
 * @typedef {object} ErrorMessage 에러 메시지
 * @property {string[]} name 폼의 네임 페스
 * @property {string[]} errors 폼의 에러 메시지
 */

/**
 * 국제화 메시지 처리
 * TODO 국제화 라이브러리 도입되면 삭제할 훅입니다.
 * @returns { formattedErrors }
 */
export default function useIntl() {
  const { locale } = useContext(LocaleContext);

  /**
   * locale로 메시지를 변환한다.
   * ? src\pages\utils.js의 localeKeyToString와는 키값(key → id) 및 변수를 replace할 대상({{ → {)이 다름
   * @param {Message} msg 변환할 메시지
   * @returns string
   */
  const formattedMsgs = (msg) => {
    let result = locale.resource[msg.id];
    if (!result) {
      throw new Error('locale에서 변환할 키를 찾지 못했습니다.');
    }
    if (Object.prototype.hasOwnProperty.call(msg, 'values')) {
      Object.entries(msg.values).forEach(([index, value]) => {
        result = result.replace(`{${index}}`, value);
      });
    }
    return result;
  };

  /**
   * antd Form의 에러 객체
   * @param {Message | Message[]} items 변환할 메시지(목록)
   * @returns {ErrorMessage | ErrorMessage[]}
   */
  const formattedErrors = (items) => {
    const msgs = (errors) => errors.map((el) => formattedMsgs(el));

    // Message[]인 경우
    if (Array.isArray(items)) {
      return items.map((el) => ({ ...el, errors: msgs(el.errors) }));
    }
    // Message인 경우
    return { ...items, errors: msgs(items.errors) };
  };

  return { formattedErrors };
}
